import React, { useState, useEffect, useRef } from 'react';
import { apis, apiHolder } from 'api';
import { useAppSelector } from '@web-common/state/createStore';
import SelectList from '@web-common/components/UI/SiriusContact/selectList';
import ErrorBoundary from '@web-common/hooks/ErrorBoundary';
import { StaticRootNodeKey } from '@web-common/utils/contact_util';
import styles from './MdContentSelecter.module.scss';
import SelectedListMailDeliverWm from '@web-common/components/UI/SiriusContact/selectedListMailDeliverWm';
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const systemApi = apiHolder.api.getSystemApi();
const MdContentSelecter = props => {
    const { onOk, onCancel, _account } = props;
    const [searchValue, setSearchValue] = useState('');
    const { focused } = useAppSelector(state => state.contactReducer.selector);
    const isCorpMail = useAppSelector(state => state.loginReducer.loginInfo.isCorpMailMode);
    const shouldShowOrgContact = !isCorpMail;
    const focusedRef = useRef(focused);
    useEffect(() => {
        focusedRef.current = focused;
    }, [focused]);
    const [selectList, setSelectList] = useState([]);
    const handleSelect = async (itemList) => {
        setSelectList(itemList);
    };
    const handleContactDelete = (item) => {
        setSelectList(item);
    };
    return (React.createElement(ErrorBoundary, { name: "writeContact" },
        React.createElement("div", { className: styles.warp },
            React.createElement("div", { className: styles.left },
                React.createElement(SelectList, { containerHeight: "100%", shouldShowOrgContact: shouldShowOrgContact, showAddTeamBtn: true, showAddOrgBtn: true, showNoDataPlaceholder: true, type: ['enterprise'], order: ['enterprise'], defaultExpandedKeys: [StaticRootNodeKey.ENTERPRISE], isIM: false, showCheckbox: true, multiple: true, onSelect: handleSelect, defaultSearchVal: searchValue, useEdm: process.env.BUILD_ISEDM, isCustomerFirst: process.env.BUILD_ISEDM, searchListProps: { showAvatar: false }, useMultiAccount: false, showOrgMemberNum: true, flattenPersonalEmails: true, deduplicationByEmail: false, accountRootKey: _account, defaultSelectList: selectList })),
            React.createElement("div", { className: styles.right },
                React.createElement(SelectedListMailDeliverWm, { selectList: selectList, showPosition: true, onDelete: handleContactDelete, onSure: onOk, onCancel: onCancel, canSure: selectList.length > 0 })))));
};
export default MdContentSelecter;
